import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from './Toast';
import { firstSetup } from '../api/auth';
import { passwordError, passwordChecks } from '../utils/password';

const isValidPhone = (p) => /^\d{10}$/.test(String(p || ''));
const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || ''));

// Hiện ở LẦN ĐĂNG NHẬP ĐẦU (mustChangePassword): bắt đặt email/SĐT + mật khẩu mạnh.
// Không thể đóng cho tới khi thiết lập xong.
export default function FirstSetupModal() {
  const { me, setMe } = useAuth();
  const toast = useToast();
  const [email, setEmail] = useState(me.email || '');
  const [phone, setPhone] = useState(me.phone || '');
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [saving, setSaving] = useState(false);
  const checks = passwordChecks(pwd);

  async function submit() {
    if (saving) return;
    if (!email.trim() && !phone.trim()) return toast('Nhập email hoặc số điện thoại', 'warn');
    if (email && !isValidEmail(email)) return toast('Email không hợp lệ', 'warn');
    if (phone && !isValidPhone(phone)) return toast('Số điện thoại phải gồm 10 chữ số', 'warn');
    const perr = passwordError(pwd);
    if (perr) return toast('Mật khẩu: ' + perr, 'warn');
    if (pwd !== pwd2) return toast('Mật khẩu nhập lại không khớp', 'warn');
    setSaving(true);
    try {
      const res = await firstSetup({ email: email.trim(), phone: phone.trim(), newPassword: pwd });
      setMe(res.me);
      toast('Đã thiết lập tài khoản. Lần sau đăng nhập bằng email/SĐT + mật khẩu mới.');
    } catch (err) {
      toast(err.response?.data?.message || 'Có lỗi xảy ra', 'danger');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-bg show">
      <div className="modal" style={{ width: 'min(440px, 92vw)' }}>
        <h3>🔐 Thiết lập tài khoản lần đầu</h3>
        <div className="small muted" style={{ marginBottom: 14 }}>
          Xin chào <b>{me.name}</b>. Vui lòng đặt <b>email hoặc số điện thoại</b> để đăng nhập và <b>đổi mật khẩu</b> mới.
        </div>

        <div className="two-col">
          <div className="field">
            <label>Email (đăng nhập)</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vd: ban@congty.com"
              style={email && !isValidEmail(email) ? { borderColor: 'var(--danger)' } : undefined} />
          </div>
          <div className="field">
            <label>Số điện thoại (đăng nhập)</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="10 chữ số"
              style={phone && !isValidPhone(phone) ? { borderColor: 'var(--danger)' } : undefined} />
          </div>
        </div>
        <div className="small muted" style={{ marginTop: -4 }}>Cần ít nhất 1 trong 2 (email hoặc SĐT).</div>

        <div className="field" style={{ marginTop: 12 }}>
          <label>Mật khẩu mới</label>
          <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} autoComplete="new-password" />
        </div>
        <div className="row" style={{ gap: 12, flexWrap: 'wrap', margin: '2px 0 8px' }}>
          {checks.map((c) => (
            <span key={c.label} className="small" style={{ color: c.ok ? 'var(--ok)' : 'var(--muted)' }}>
              {c.ok ? '✓' : '○'} {c.label}
            </span>
          ))}
        </div>
        <div className="field">
          <label>Nhập lại mật khẩu mới</label>
          <input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} autoComplete="new-password"
            style={pwd2 && pwd2 !== pwd ? { borderColor: 'var(--danger)' } : undefined} />
        </div>

        <div className="row" style={{ marginTop: 16 }}>
          <div className="spacer" />
          <button className="btn" onClick={submit} disabled={saving}>
            {saving ? 'Đang lưu…' : 'Hoàn tất'}
          </button>
        </div>
      </div>
    </div>
  );
}
